import React from 'react';
import { NavLink,  } from 'react-router-dom';

export default function Title({title, backDestination = null}: {title: string, backDestination?: string|null }) {
     
    
    return (
        <header className="slice-header">
            <h1>
                <span className="icon"></span><span className="text">{title}</span>
            </h1>
            {backDestination !== null && (
                <nav>
                    <NavLink to={backDestination}  className="back">
                        <span className="icon"></span>
                        <span className="text">Retour</span>
                    </NavLink>
                </nav>
            )}
        </header>
    );
}